import { useIncompleteChainedTransfersQuery } from '@shared/graphql'

import { ResumeTransferBannerMultiple } from './ResumeTransferBanner.Multiple'
import { ResumeTransferBannerSingle } from './Single/ResumeTransferBanner.Single'

export interface ResumeTransferBannerProps {
  /**
   * Variant of banner depending on the page it is displayed.
   */
  variant?: 'home' | 'wallet'
}

export const ResumeTransferBanner: React.FC<ResumeTransferBannerProps> = ({
  variant = 'home',
}) => {
  const { data } = useIncompleteChainedTransfersQuery({
    fetchPolicy: 'cache-and-network',
  })

  const transfers = data?.incompleteChainedTransfers

  if (transfers == null || transfers.length === 0) {
    return null
  }

  // If there is only one incomplete transfer, the banner will link directly to the modal to resume the transfer.
  if (transfers.length === 1) {
    return (
      <ResumeTransferBannerSingle
        amount={transfers[0].amount}
        id={transfers[0].id}
      />
    )
  }

  // If there are multiple incomplete transfers, the banner will link to the general wallet page.
  return <ResumeTransferBannerMultiple variant={variant} />
}
